import { Facebook, Instagram, Youtube, ArrowRight, Loader2 } from "lucide-react";
import { IMAGES } from "../lib/data";
import { PageHeader } from "../components/PageHeader";
import { Btn } from "../components/ui-kit";
import { Reveal } from "../lib/motion";
import { useContent, resolveImg } from "../lib/api";

export default function Leadership() {
  const { data: LEADERS, loading } = useContent("leaders");
  return (
    <div data-testid="leadership-page">
      <PageHeader eyebrow="Our Team" title={"Meet Our\nLeadership"} sub="Meet the leaders who faithfully serve, guide, and support the vision of One Love Ministries." image={IMAGES.pastor} />

      <section className="py-24 sm:py-32 bg-white">
        {loading && <div className="py-10 grid place-items-center"><Loader2 className="animate-spin text-[#E63946]" size={32} /></div>}
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {(LEADERS || []).map((l, i) => (
            <Reveal key={l.id || l.name} delay={(i % 3) * 0.1} className="group">
              <div className="overflow-hidden rounded-sm aspect-[4/5] mb-6 bg-[#0A0A0A]">
                {l.image ? (
                  <img src={resolveImg(l.image)} alt={l.name} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700" />
                ) : (
                  <div className="w-full h-full grid place-items-center bg-gradient-to-br from-[#1A1A1A] to-[#0A0A0A] relative grain">
                    <span className="font-display font-extrabold text-white/90 text-6xl">{l.name.split(" ").map((w) => w[0]).slice(0, 2).join("")}</span>
                    <span className="absolute bottom-5 h-1 w-12 bg-[#E63946]" />
                  </div>
                )}
              </div>
              <p className="text-xs uppercase tracking-[0.2em] text-[#E63946] mb-2">{l.title}</p>
              <h3 className="font-display font-bold text-2xl mb-3">{l.name}</h3>
              <p className="text-black/60 leading-relaxed mb-4">{l.bio}</p>
              <p className="text-sm text-black/50 mb-5"><span className="font-medium text-black/70">Serves in:</span> {l.responsibilities}</p>
              <div className="flex gap-2">
                {[Facebook, Instagram, Youtube].map((Icon, k) => (
                  <a key={k} href="#" aria-label="social" className="grid place-items-center w-10 h-10 rounded-full border border-black/10 hover:bg-[#E63946] hover:text-white hover:border-[#E63946] transition-colors"><Icon size={16} /></a>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="bg-[#0A0A0A] text-white">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 text-center">
          <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl mb-6">Called to serve alongside us?</h2>
          <Btn to="/contact?subject=Ministry%20Information" testid="leadership-cta">Connect With Our Team <ArrowRight size={16} /></Btn>
        </div>
      </section>
    </div>
  );
}
